<template>
  <vue-recaptcha class="vue-recaptcha-container"
    sitekey="6Lc01QgTAAAAAHBnsjWB7UkhmYRtnwSlJlafkYEk"
    ref="recaptcha"
    @verify="onVerify"
    @expired="onExpired">
  </vue-recaptcha>
</template>

<script>
  import VueRecaptcha from 'vue-recaptcha';
  export default {
    data: () => {
      return {
        value: null
      }
    },
    components: { VueRecaptcha },
    methods: {
      onVerify: function (response) {
        this.value = response
      },
      onExpired: function () {
        this.resetRecaptcha()
      },
      resetRecaptcha () {
        this.value = null
        this.$refs.recaptcha.reset()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// lib/brave-authentication/components/recaptcha.vue